const t = {
    name: `root`,
    seq: [
        `walk_to_door`,
        {
            name: `door_locked`,
            sel: [
                `open_door`,
                {
                    name: `open_locked_door`,
                    seq: [`unlock_door`, `open_door`]
                },
                `smash_door`
            ]
        },
        `walk_through_door`,
        `close_door`
    ]
};
const getName = (t, defaultValue = ``) => {
    if (typeof t === `object` && `name` in t && t.name !== undefined)
        return t.name;
    return defaultValue;
};
//eslint-disable-next-line func-style
export function* iterateBreadth(t, pathPrefix) {
    if (typeof pathPrefix === `undefined`) {
        pathPrefix = getName(t);
    }
    for (const [index, n] of entries(t)) {
        yield [n, pathPrefix];
    }
    for (const [index, n] of entries(t)) {
        const name = getName(n, `?`);
        const prefix = pathPrefix.length > 0 ? pathPrefix + `.` + name : name;
        yield* iterateBreadth(n, prefix);
    }
}
//eslint-disable-next-line func-style
export function* iterateDepth(t, pathPrefix) {
    if (typeof pathPrefix === `undefined`) {
        pathPrefix = getName(t);
    }
    for (const [index, n] of entries(t)) {
        yield [n, pathPrefix];
        const name = getName(n, `?`);
        const prefix = pathPrefix.length > 0 ? pathPrefix + `.` + name : name;
        yield* iterateBreadth(n, prefix);
    }
}
//eslint-disable-next-line func-style
function isSeqNode(n) {
    return n.seq !== undefined;
}
//eslint-disable-next-line func-style
function isSelNode(n) {
    return n.sel !== undefined;
}
//eslint-disable-next-line func-style
function* entries(n) {
    if (isSeqNode(n)) {
        yield* n.seq.entries();
    }
    else if (isSelNode(n)) {
        yield* n.sel.entries();
    }
    else if (typeof n === `string`) {
        // no-op
    }
    else {
        throw new TypeError(`Unexpected shape of node. seq/sel missing`);
    }
}
// for (const tn of iterateBreadth(t)) {
//   console.log(`Path: ${ tn[ 1 ] }`);
//   console.log(`Node: ${ JSON.stringify(tn[ 0 ]) }`);
// }
// console.log(`---`);
// for (const tn of iterateDepth(t)) {
//   console.log(`Path: ${ tn[ 1 ] }`);
//   console.log(`Node: ${ JSON.stringify(tn[ 0 ]) }`);
// }
